import React from 'react';
import DashboardOverviewEvaluations from '@/features/dashboard-eval/components/DashboardOverviewEvaluations';
import ParentLayout from './ParentLayout';

export default function Layout() {
  return (
    <ParentLayout title="Evaluations">
      {function(params) {
        return (
          <>
            <DashboardOverviewEvaluations params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
